<template>
  <div class="trial-expire-risk arrow-box">
    <div class="title">
      PPT演示模式上线啦
    </div>
    <div class="content">
      <div class="content-row">
        逐页演示你的动画，演示节奏你来把控。
      </div>
      <div class="content-row">
        赶快来试试吧！
      </div>
    </div>
    <div class="button-row">
      <div class="btn" @click.stop="confirm">确定</div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'UserMsg'
    ])
  },
  methods: {
    confirm () {
      this.$emit('input', false);
    }
  }
}
</script>

<style lang="scss" scoped>
.trial-expire-risk {
  color: #333;
  background-color: #fff;
  text-align: left;
  width: 288px;
  min-height: 166px;
  background:
    url(../../assets/vipTrialMessage/bg-expire-popover.png) right top/100% 80% no-repeat, #fff;
  box-shadow: 0px 2px 12px rgba(0,0,0,0.1600);
  opacity: 1;
  border-radius: 4px;
  .title {
    padding-top: 24px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px;
    font-size: 16px;
    font-weight: bold;
    line-height: 1;
    .strong {
      color: #5778FB;
    }
  }
  .content {
    padding-left: 24px;
    padding-right: 24px;
    font-size: 12px;
    line-height: 1.8;
    color: #666666;
  }
  .button-row {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 17px;
    padding-bottom: 20px;
  }
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 126px;
  height: 38px;
  background: #5778FB;
  opacity: 1;
  border-radius: 4px;
  color: #fff;
  &:hover {
    background-color: #7d95f5;
  }
}

.arrow-box {
	position: relative;
}
.arrow-box:after {
	bottom: 100%;
	left: calc(50% + 4px);
	border: solid transparent;
	content: "";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
	border-color: rgba(136, 183, 213, 0);
	border-bottom-color: #FDECFC;
	border-width: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/presentationTip.vue